module.exports = __webpack_public_path__ + "img/thumb_29.73b0ee69.jpg";